import { MovieEditIcon } from './MovieEditIcon';

/**
 * author: Christopher Schreiner
 * id EBABD564-B269-4D31-995B-062C7EBEFC15
 * name movie-edit
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-edit.svg
 * tags
 * - Video / Movie 
 * - Edit / Modify 
 */
export const FilmEditIcon = MovieEditIcon;
export default FilmEditIcon